import { reactive, readonly } from "@vue/composition-api";
import Api from '@/plugin/Api';
import {  DashboardQueryResponseDto, DashboardService, LearnerStatisticsDetailDto } from "@/generated/api.clients";

const dashboardApi = new DashboardService(undefined, Api);

const state = reactive({
  dashboardData: new DashboardQueryResponseDto({
    overallStatisticsForAllRoles: undefined,
    statisticsByLEA:[],
    statisticsByRole:[],
    averageObserverLoad:[],
    yearlyRatingSummary: [],
    yearlyRatingSummaryByRole: []
  }),
  learnerDetails: new Array<LearnerStatisticsDetailDto>(),
})

const actions = {
  async loadDashboard(lea: string, districtOnly: boolean): Promise<void> {
    state.dashboardData = await dashboardApi.getDashboard(lea, districtOnly)
    state.learnerDetails = await dashboardApi.getDashboardLearnerDetails(lea, districtOnly)
  },
}
const getters = {
}

export default {
    state: readonly(state),
    actions,
    getters
}